import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DemoChooserModal from "../components/demo/DemoChooserModal";

const DemoChooserContext = createContext(null);

export function DemoChooserProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("social");
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    if (params.get("try_demo") !== "1") return;
    setMode("social");
    setOpen(true);
    const next = new URLSearchParams(params);
    next.delete("try_demo");
    setParams(next, { replace: true });
  }, [params, setParams]);

  const openDemoChooser = useCallback(() => {
    setMode("social");
    setOpen(true);
  }, []);

  const openClassDemoChooser = useCallback(() => {
    setMode("class");
    setOpen(true);
  }, []);

  const closeDemoChooser = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ openDemoChooser, openClassDemoChooser, closeDemoChooser }),
    [openDemoChooser, openClassDemoChooser, closeDemoChooser],
  );

  return (
    <DemoChooserContext.Provider value={value}>
      {children}
      <DemoChooserModal open={open} mode={mode} onClose={closeDemoChooser} />
    </DemoChooserContext.Provider>
  );
}

export function useDemoChooser() {
  const ctx = useContext(DemoChooserContext);
  if (!ctx) {
    throw new Error("useDemoChooser must be used within DemoChooserProvider");
  }
  return ctx;
}
